import { generateResourceOperationMap } from '@modules/common/components/CanAccess/utils/generateResourceOperationMap';
import { PermissionOperation } from 'generated/graphql';
import {
  PermissionResourceType,
  UserPermissionType,
} from 'v2/core/entities/user';

export const getAllowedOperation = (
  permissions: UserPermissionType[],
  resource: PermissionResourceType | undefined,
): PermissionOperation | undefined => {
  if (!resource) {
    return;
  }

  const resourceOperationMap = generateResourceOperationMap(permissions);
  const allowedOperation = resourceOperationMap.get(resource);

  return allowedOperation;
};
